import {Injectable} from '@angular/core';

/**
 * Translations for club-overview list.
 */
@Injectable()
export class ClubListTranslationsService {
  public i18nSuccessClubCreate: any = $localize`:@@alertService.alert.success.clubCreate:Club was created successfully!`;
  public i18nErrorClubCreate: any = $localize`:@@alertService.alert.error.clubCreate:Error occurred. Club could not be created.`;
  public i18nClubNameExists: any = $localize`:@@alert.error.clubNameExists:Club with this name already exists.`;
  public i18nErrorFetchingClubs: any = $localize`:@@alertService.alert.error.fetchingClubs:Error occurred. Could not fetch clubs.`;

  constructor() { }
}
